"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hookInput = exports.hookLabel = exports.debugProp = exports.button = exports.consoleWrapper = void 0;
exports.consoleWrapper = {
    position: 'fixed',
    bottom: 20,
    right: 20,
    width: 200,
    zIndex: 200000000,
    backgroundColor: 'rgba(0,0,0,0.8)',
    color: 'red',
    paddingBottom: 8,
    paddingTop: 8,
};
exports.button = {
    position: 'fixed',
    bottom: 20,
    left: 20,
    zIndex: 200000000,
    padding: 8,
    backgroundColor: 'rgba(0,0,0,0.8)',
    color: 'red',
};
exports.debugProp = {
    paddingLeft: 16,
    paddingBottom: 8,
    paddingTop: 8,
    alignItems: 'center',
};
exports.hookLabel = {
    whiteSpace: 'nowrap',
    paddingBottom: 8,
    fontSize: 16,
};
exports.hookInput = {
    color: '#000',
    fontSize: '16px',
};
//# sourceMappingURL=styles.js.map